import axios from 'axios';
import axiosInstance from './axios';
import AuthData from 'types/models/AuthData';
import User from 'types/models/User';
import { BASE_URL } from '@env';

export const loginEmail = async (email: string, password: string, expoPushToken?: string): Promise<AuthData | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: '/login/moderator',
      data: {
        email,
        password,
        expoPushToken,
      },
    });
    return parseAuthData(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const loginWithAuthorizationCode = async (authorizationCode: string): Promise<AuthData | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: '/login/editor-authorization-code?fromCashless=1',
      data: {
        authorizationCode,
      },
    });
    return parseAuthData(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAuthData = async (token: string): Promise<User | null> => {
  try {
    const { data } = await axios.get(`${BASE_URL}auth`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return parseUser(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

const parseAuthData = (data: any): AuthData => {
  return {
    token: data.token,
    user: parseUser(data.user),
  };
};

export const parseUser = (data: any): User => {
  return {
    id: data.id,
    email: data.email,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
    role: data.role_id,
    name: data.name,
    googleId: data.googleId,
    facebookId: data.googleId,
    identificationNumber: data.dni ?? null,
  };
};
